import React from 'react';

const AsSeenIn = () => {
  const mediaLogos = [
    {
      name: "Forbes",
      url: "https://visaeb-5.com/wp-content/uploads/2022/08/forbes@2x-300x78.png"
    },
    {
      name: "The Economic Times",
      url: "https://visaeb-5.com/wp-content/uploads/2022/08/the-economic-times-logo@3x-300x28.png"
    },
    {
      name: "The Real Deal",
      url: "https://visaeb-5.com/wp-content/uploads/2022/08/the-real-deal-logo-300-x-180@2x-300x48.png"
    },
    {
      name: "Times of India",
      url: "https://visaeb-5.com/wp-content/uploads/2022/08/toi-logo@3x-300x22.png"
    }
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-center text-[#c94a4a] text-lg italic mb-6">As Seen In</h3>
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16 lg:gap-20">
          {mediaLogos.map((logo, index) => (
            <img
              key={index}
              src={logo.url}
              alt={logo.name}
              className="h-5 md:h-6 lg:h-7 object-contain opacity-90 hover:opacity-100 transition-opacity"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AsSeenIn;
